import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, PRICE_CONFIGURATIONS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const ClosedShipmentList = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'invoiceCheckerID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentID',
				filterType: FilterType.string
			},
			{
				Header: 'otoOrderID',
				accessor: 'orderID',
				filterType: FilterType.string
			},
			{
				Header: 'deliveryCompanyID',
				accessor: 'deliveryCompanyID',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'deliveryCompanyChargedWeight',
				accessor: 'deliveryCompanyChargedWeight',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'deliveryCompanyChargedAmount',
				accessor: 'deliveryCompanyChargedAmount',
				filterType: FilterType.float
			},
			{
				Header: 'uploadDate',
				accessor: 'uploadDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'clientID',
				accessor: 'clientID',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'otoOrderWeight',
				accessor: 'orderWeight',
				filterType: FilterType.float,
				show: false
			},
			{
				Header: 'additionalWeight',
				accessor: 'additionalWeight',
				filterType: FilterType.float
			},
			{
				Header: 'lastStatusOfShipment',
				accessor: 'lastStatusOfShipment',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.SHIPMENT_STATUS,
				renderCellProps: {
					ID: 'orderID',
					orderID: 'ID'
				},
				show: false
			},
			{
				Header: 'lastStatusDate',
				accessor: 'lastStatusDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATE
			},
			{
				Header: 'shipmentType',
				accessor: 'shipmentType',
				filterType: FilterType.enumMulti,
				enumData: ['forward', 'failed', 'reverse']
			},
			{
				Header: 'deliveryCompanySettingID',
				accessor: 'deliveryCompanySettingsID',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'clientChargedCredit',
				accessor: 'clientChargedCredit',
				filterType: FilterType.float
			},
			{
				Header: 'manuallyChargedCredit',
				accessor: 'manuallyChargedCredit',
				filterType: FilterType.float
			},
			{
				Header: 'creditDescription',
				accessor: 'creditDescription',
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'contractName',
				accessor: 'contractName',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'originTier',
				accessor: 'originTier',
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'destinationTier',
				accessor: 'destinationTier',
				filterType: FilterType.multiSelection,
				show: false
			},
			{
				Header: 'difference',
				accessor: 'difference',
				filterType: FilterType.float
			},
			{
				Header: 'priceMargin',
				accessor: 'priceMargin',
				filterType: FilterType.float
			},
			{
				Header: 'codMargin',
				accessor: 'codMargin',
				filterType: FilterType.float,
				showOnMobile: true
			},
			{
				Header: 'surplusLoss',
				accessor: 'discrepancy',
				filterType: FilterType.float
			},
			{
				Header: 'chargeReason',
				accessor: 'chargeReason',
				filterType: FilterType.string,
				translate: true,
				renderCell: ListComponents.STRING_ARRAY
			},
			{
				Header: 'correctionStatus',
				accessor: 'correctionStatus',
				showOnMobile: true,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CORRECTION_STATUS,
				renderCell: ListComponents.STATUS
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.CLOSED_SHIPMENTS}
				columns={columns}
				fetchUrl={PRICE_CONFIGURATIONS.GET_CLOSED_SHIPMENTS_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="closedShipments"
			/>
		</TabTableContainer>
	);
};

export default ClosedShipmentList;
